export default __webpack_public_path__ + "static/media/app-store.3d2ec00b.svg";